import { render, staticRenderFns } from "./offlineInsuranceDetail.vue?vue&type=template&id=1228859a"
import script from "./offlineInsuranceDetail.vue?vue&type=script&lang=js"
export * from "./offlineInsuranceDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports